import { render } from "./indexnavLevel.vue?vue&type=template&id=45a586da&scoped=true&ts=true"
import script from "./indexnavLevel.vue?vue&type=script&lang=ts"
export * from "./indexnavLevel.vue?vue&type=script&lang=ts"

import "./indexnavLevel.vue?vue&type=style&index=0&id=45a586da&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a586da"]])

export default __exports__